import { adminSessionStorage } from './adminSession'
import { createClient } from '@supabase/supabase-js'

/** Jumpstart platform — auth + org data (primary admin portal session lives here today). */
const supabaseUrl = 'https://dgxnnwnugdxzeopleera.supabase.co'
const supabaseAnonKey = 'sb_publishable_Uvr3BAwELJRoqXHFs7x7kQ_u2HCxSgm'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, { auth: { storage: adminSessionStorage } })

/**
 * Otomator Admin Supabase — `whatsapp-proxy` Edge Function + `central_subscriptions`.
 * Do not call the WhatsApp host directly from the browser.
 */
const adminSupabaseUrl = 'https://mzalzjtsyrjycaxolldv.supabase.co'
const adminSupabaseAnonKey =
  'sb_publishable_WaxdB5nlc8Hp1eEuZACjOA_sQKRhYH1'

export const adminSupabase = createClient(adminSupabaseUrl, adminSupabaseAnonKey)

export const ADMIN_EMAIL = 'nizan@otomator.co.il'

/** WhatsApp Service product row in `products` (otomator-admin Supabase). */
export const WHATSAPP_SERVICE_PRODUCT_ID = 'dcb75b3d-b326-4803-bed8-0532727313cb'

/** Public Edge Function — SUMIT payment flow for WhatsApp plans (no JWT). */
export const SUMIT_WHATSAPP_URL = `${adminSupabaseUrl}/functions/v1/sumit-whatsapp`
